import styled from "styled-components";

export const Box = styled.div`
  background: #0A0E27;
  border-radius: 20px;
`;
